import React, {useEffect, useState} from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import CircularProgress from "../_UI/circularProgress";

import cfpIcon from '../../theme/assets/other/ftf_cfp_icon.png';
import {
    setMatrixBuyModalStatus,
    setMatrixSellModalStatus,
    setMatrixSellWarningModalStatus
} from "../../store/cabinet/action";
import {useTranslation} from "react-i18next";


const CabinetMatrixMain = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const matrix = useSelector(store => store.cabinet.matrix);
    const userData = useSelector(store => store.cabinet.userData);

    const [activeTriplet, setActiveTriplet] = useState(false);


    const barStyleHandler = (status) => {
      switch (status){
          case 'active':
              return {
                  barTextColor: '#FFEE00',
              }
          case 'inactive':
              return {
                  barTextColor: '#8f8885'
              }
          case 'closed':
              return {
                  barTextColor: '#8c8521'
              }
          default:
              return {
                  barTextColor: '#8f8885'
              }
      }
    }


    const ticketsHandler = (isBuy) =>{
        if (isBuy){
            dispatch(setMatrixBuyModalStatus(true));
        } else {
            if (!!localStorage.getItem('ftf-swms')){
                dispatch(setMatrixSellModalStatus(true));
            } else {
                dispatch(setMatrixSellWarningModalStatus(true));
            }
        }
    }

    useEffect(()=>{
        if (matrix){
            const activeIndex = matrix.findIndex(item => item.status === "active");


            if (activeIndex === -1) {
                setActiveTriplet(matrix.slice(0, 3));
            } else {
                if (activeIndex === 0) {
                    setActiveTriplet(matrix.slice(0, 3));
                } else if (activeIndex === matrix.length - 1) {
                    setActiveTriplet(matrix.slice(matrix.length - 3))
                } else {
                    setActiveTriplet(matrix.slice(activeIndex - 1, activeIndex + 2))
                }
            }
        }
    },[matrix])

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={`${Styles.contentWrapTitle}`}>CFP</div>
                <div className={`${Styles.contentWrapNote}`}>
                    {t('Crypto for People — это сердце нашей экосистемы, созданное для справедливого распределения ценности между людьми, а не фондами и инсайдерами. Ты точно знаешь, за что платишь: прозрачная цена, понятные этапы и честная экономика, в которой ценность формируется действиями сообщества')}.
                </div>
                <div className={`${Styles.balanceRow}`}>
                    <div className={`${Styles.balanceRowName}`}>{t('Ваш баланс токенов')}:</div>
                    <div className={`${Styles.balanceRowValueBox}`}>
                        <div className={`${Styles.balanceRowValueBoxIcon}`}>
                            <img src={cfpIcon} alt="cfp token"/>
                        </div>
                        <div className={`${Styles.balanceRowValue}`}>{userData?.user?.coins ? userData.user.coins * 1 : '0'}</div>
                    </div>
                </div>
                <div className={Styles.matrixWrap}>
                    {activeTriplet ? activeTriplet.map((item, index)=>{
                        return (
                            <div className={`${Styles.matrixItem} ${item.status === 'active' ? Styles.matrixItemActive : null} ${item.status === 'closed' ? Styles.matrixItemClosed : null} ${item.status === 'inactive' ? Styles.matrixItemInactive : null}`} key={'matrixItem' + index}>
                                <div className={Styles.matrixItemLap}>{t('Круг')} #{item.order}</div>
                                <div className={Styles.matrixItemBarBox}>
                                    <CircularProgress current={item.places_left} total={item.places} styleData={barStyleHandler(item.status)}/>
                                </div>
                                <div className={Styles.matrixItemPrice}>{t('Цена токена')}: <span>{item.price * 1}$</span></div>
                            </div>
                        )
                    }) : null}
                </div>
                <div className={Styles.btnsWrap}>
                    <div className={Styles.btnsWrapItem} onClick={()=>{ticketsHandler(true)}}>{t('Купить токены')}</div>
                    <div className={Styles.btnsWrapItem} onClick={()=>{ticketsHandler(false)}}>{t('Продать токены')}</div>
                </div>
            </div>
        </section>
    );
};

export default CabinetMatrixMain;